import React, { useEffect } from 'react';

import MyAccount from './MyAccount';
import BillingInformation from './BillingInformation';
import AccountCompanySection from './AccountCompanySection';
import Subscription from './Subscription';

import { useState } from 'react';
import { useRouter } from "next/router";

import UserIcon from 'assets/icons/user-icon.svg';

import classes from './DesktopSettings.module.scss';

const DesktopSettings = ({ isBusiness = false }) => {
	const router = useRouter();
	const { active_tab } = router.query;	 	 
	const [activeSection, setActiveSection] = useState('account');
	useEffect(() => {
		if(active_tab)
			setActiveSection(active_tab);
	  }, [active_tab]);

	return (
		<>
			<div className={`row ${classes['desktop-container']}`}>
				<div
					className={`col-3 d-flex flex-column align-items-start pt-2 ${classes['setting-sections']}`}>
					<button
						onClick={() => setActiveSection('account')}
						className={activeSection === 'account' ? classes['active-section'] : ''}>
						My Account
					</button>
					{!isBusiness && (
						<>
							<button
								onClick={() => setActiveSection('subscription')}
								className={activeSection == 'subscription' ? classes['active-section'] : ''}>
								Subscription
							</button>
							<button
								onClick={() => setActiveSection('billing')}
								className={activeSection === 'billing' ? classes['active-section'] : ''}>
								Billing Information
							</button>
						</>
					)}
					{isBusiness && (
						<button
							onClick={() => setActiveSection('company')}
							className={activeSection === 'company' ? classes['active-section'] : ''}>
							My Company
						</button>
					)}

				</div>
				<div className={`col-9 pt-2 ${classes['section-content']}`}>
					{activeSection === 'account' && (
						<div className={`${classes['account-section']}`}>
							<h2 className="d-flex flex-row align-items-center gap-3 mb-5">
								<UserIcon /> My Account
							</h2>
							<MyAccount />
						</div>
					)}
					{activeSection === 'billing' && (
						<div>
							<BillingInformation />
						</div>
					)}
					{activeSection === 'company' && (
						<div>
							<AccountCompanySection />
						</div>
					)}
					{activeSection === 'subscription' && (
						<div>
							<Subscription />
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default DesktopSettings;
